/**
 * Button state manager for product bundles
 * Handles enabling/disabling the "Order Now" button
 */
(function() {
    'use strict';
    
    window.BundleButtonManager = window.BundleButtonManager || {};

    /**
     * Disable the order button with full protection
     * @param {HTMLElement} bundleElement - The bundle element
     * @param {Function} debugLog - Debug logging function
     * @param {string} reason - Optional reason message to display
     */
    window.BundleButtonManager.disableOrderButton = function(bundleElement, debugLog, reason) {
        const button = bundleElement.querySelector('[data-bundle-addToCart], [data-bundle-addtocart]');
        if (!button) return;
        
        debugLog('🔒 [ProductBundle] Disabling order button...', reason || '');
        
        // Store original value if not already stored
        if (!button.dataset.originalValue) {
            button.dataset.originalValue = button.value || button.textContent;
        }
        
        // Update button text if reason provided
        if (reason) {
            button.value = reason;
        }
        
        // Change input type from submit to button to prevent form submission
        if (button.tagName === 'INPUT' && button.type === 'submit') {
            button.dataset.originalType = 'submit';
            button.type = 'button';
        }
        
        // Add blocking overlay
        if (!button.parentElement.querySelector('.button-blocking-overlay')) {
            const overlay = document.createElement('div');
            overlay.className = 'button-blocking-overlay';
            overlay.style.cssText = 'position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: transparent; z-index: 9999; pointer-events: all;';
            button.style.position = 'relative';
            button.parentElement.insertBefore(overlay, button);
        }
        
        // Block all interactions in capture phase
        // Store the handler so we can remove it later
        if (!button._blockEventHandler) {
            button._blockEventHandler = (e) => {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                return false;
            };
        }
        
        ['click', 'mousedown', 'mouseup', 'touchstart', 'touchend', 'focus'].forEach(eventType => {
            button.addEventListener(eventType, button._blockEventHandler, true); // Capture phase
        });
        
        // Set disabled attributes
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.tabIndex = -1;
        if (button.tagName === 'INPUT') {
            button.readOnly = true;
        }
        
        // Apply visual disabled styles
        button.style.opacity = '0.6';
        button.style.backgroundColor = '#ccc';
        button.style.color = '#666';
        button.style.borderColor = '#999';
        button.style.pointerEvents = 'none';
        button.style.cursor = 'not-allowed';
        button.style.userSelect = 'none';
        
        // Add disabled classes
        button.classList.add('button--disabled', 'button--loading');
    };

    /**
     * Enable the order button
     * @param {HTMLElement} bundleElement - The bundle element
     * @param {Function} debugLog - Debug logging function
     */
    window.BundleButtonManager.enableOrderButton = function(bundleElement, debugLog) {
        const button = bundleElement.querySelector('[data-bundle-addToCart], [data-bundle-addtocart]');
        if (!button) return;
        
        debugLog('✅ [ProductBundle] Enabling order button...');
        
        // CRITICAL: Remove event listeners that were added in disableOrderButton
        if (button._blockEventHandler) {
            ['click', 'mousedown', 'mouseup', 'touchstart', 'touchend', 'focus'].forEach(eventType => {
                button.removeEventListener(eventType, button._blockEventHandler, true); // Capture phase
            });
            button._blockEventHandler = null;
        }
        
        // Remove blocking overlay
        const overlay = button.parentElement.querySelector('.button-blocking-overlay');
        if (overlay) {
            overlay.remove();
        }
        
        // Restore input type
        if (button.tagName === 'INPUT' && button.dataset.originalType === 'submit') {
            button.type = 'submit';
            delete button.dataset.originalType;
        }
        
        // Remove disabled attributes
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        button.tabIndex = 0;
        if (button.tagName === 'INPUT') {
            button.readOnly = false;
        }
        
        // Remove visual disabled styles
        button.style.removeProperty('opacity');
        button.style.removeProperty('backgroundColor');
        button.style.removeProperty('color');
        button.style.removeProperty('borderColor');
        button.style.removeProperty('pointerEvents');
        button.style.removeProperty('cursor');
        button.style.removeProperty('userSelect');
        
        // Remove disabled classes
        button.classList.remove('button--disabled', 'button--loading');
    };
})();
